/** Display / fallback amounts for new SFBB Pro pricing (existing Stripe subs unchanged). */
export const BASE_SUBSCRIPTION_PRICE = 25.95;
export const ADDITIONAL_LOCATION_PRICE = 12.95;
export const PRINTER_PRICE = 99.95;

export const formatGbp = (amount) =>
  `£${Number(amount).toFixed(2)}`;
